// extracted by mini-css-extract-plugin
module.exports = {"priceSectionItem":"PriceSectionItem_priceSectionItem__fEA6I","priceListItem":"PriceSectionItem_priceListItem__1LIyU","priceItemList":"PriceSectionItem_priceItemList__37XDF"};